'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinanceList = _react2.default.createClass({
    displayName: 'FinanceList',

    propTypes: {
        finances: _react.PropTypes.object.isRequired
    },
    render: function render() {
        var _this = this;

        var columns = [{
            title: '内部流水号',
            key: 'id',
            dataIndex: 'transaction_no'
        }, {
            title: '时间',
            key: 'created_at',
            dataIndex: 'created_at'
        }, {
            title: '交易类型',
            key: 'type',
            dataIndex: 'type_info'
        }, {
            title: '交易金额',
            key: 'fee',
            dataIndex: 'fee'
        }, {
            title: '支付方式',
            key: 'channel_info',
            dataIndex: 'channel_info'
        }, {
            title: '关联客户',
            key: 'payer_account',
            dataIndex: 'payer_account.owner.name'
        }, {
            title: '关联订单',
            key: 'order_id',
            dataIndex: 'order_id'
        }, {
            title: '备注',
            key: 'note',
            dataIndex: 'note'
        }];
        var finances = this.props.finances;
        var items = finances.items,
            pagination = finances.pagination,
            error = finances.error,
            isFetching = finances.isFetching;

        var pager = Object.assign(_constants.PaginationConfig, {
            total: pagination.total,
            current: pagination.current_page,
            pageSize: pagination.per_page,
            onChange: function onChange(page, pageSize) {
                // 页码改变的回调，参数是改变后的页码及每页条数
                _this.props.onChange(page);
            },
            onShowSizeChange: function onShowSizeChange(current, pageSize) {

            }
        });
        var tableConfig = {
            columns: columns,
            locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
            dataSource: items,
            loading: isFetching,
            pagination: pager,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };
        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = FinanceList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/finance_list.js
// module id = 1319
// module chunks = 0